import { portalDs } from 'src/components/portal-design-system';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/components/ui/table';
import { cn } from 'src/lib/utils';
import type { DataJobValidationResult } from '../types/data-jobs.types';
import { DataJobStatusBadgeV2 } from './data-job-status-badge-v2';

interface ValidationResultsTableProps {
  results: DataJobValidationResult[];
}

export function ValidationResultsTable({ results }: ValidationResultsTableProps) {
  return (
    <div className={portalDs.tableContainer}>
      <Table>
        <TableHeader>
          <TableRow className={portalDs.tableHead}>
            {['Target', 'Check', 'Status', 'Value', 'Threshold'].map((header) => (
              <TableHead
                key={header}
                className={portalDs.tableHeadCell}
              >
                {header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {results.map((result) => (
            <TableRow
              key={result.id}
              className={portalDs.tableBodyRow}
            >
              <TableCell className={portalDs.tableCell}>
                {result.target}
              </TableCell>
              <TableCell className={cn(portalDs.tableCell, portalDs.tableCellMuted)}>
                {result.check_type}
              </TableCell>
              <TableCell className={portalDs.tableCell}>
                <DataJobStatusBadgeV2 status={result.status} />
              </TableCell>
              <TableCell className={cn(portalDs.tableCell, portalDs.tableCellMuted)}>
                {result.value == null ? '—' : String(result.value)}
              </TableCell>
              <TableCell className={cn(portalDs.tableCell, portalDs.tableCellMuted)}>
                {result.threshold == null ? '—' : String(result.threshold)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
